import React from 'react';
import { Link } from 'operation-diameter';

export default {
  standard: {
    title:
      "Unfortunately we can't progress your application on this occasion, but we could still help you get finance.",
    subtitle:
      "We work with a range of trusted partners who can often help when we're not able to.",
    paragraphs: () => [
      "If we think they could help, an Account Manager from our Marketplace team will contact you within the next working day. They'll discuss the options available to you to find the right product for your needs."
    ],
    cardTitle: 'Your business could benefit from',
    cardItems: () => [
      'Loans, credit cards, asset finance',
      'Credit lines, property loans',
      'Competitive pricing',
      'Terms from 3 months to 6 years',
      'Dedicated Account Manager'
    ],
    rejectionQuestion: 'Why was my application for a loan unsuccessful?',
    rejectionAnswer: () => (
      <>
        We assess your application based on all the information provided, and
        it's not always possible to provide a specific reason as it could be
        many factors combined. You can find more information{' '}
        <Link href='https://www.fundingcircle.com/uk/small-business-loans/unsuccessful-applications/'>
          here
        </Link>
        .
      </>
    )
  },
  preSelected: {
    title: 'Sorry, something went wrong.',
    subtitle: '',
    paragraphs: () => [
      "Unfortunately, either we've been unable to verify your information or it doesn't match the information we used to generate your personalised offer.",
      'A sales representative will contact you regarding next steps.'
    ],
    additionalItem: () => (
      <Link href='/borrower/summary'>Return to your summary page</Link>
    )
  },
  assetFinance: {
    title: 'Thank you for applying for finance with Funding Circle',
    paragraphs: () => [
      "Following a review of your application, unfortunately we're unable to make you an offer right now.",
      'We hope that you find the finance you need for your business and wish you all the best for the future.'
    ]
  }
};
